export interface UnshareArtifactOrgsRequest {
  publicId: string
  orgIds: string[]
}
